module.exports = __webpack_public_path__ + "static/media/142.ccbfbb02.png";